angular.module('dealerware.web.data').factory('DealerwareTrimCollection', function ($http,Collection,DealerwareTrimModel,$q) {

    'use strict';
    var collection = new Collection({
        baseEndpoint: '/locations/:location_id/trims',
        rootNode: 'trims',
        model: 'DealerwareTrimModel',
        customActions: {
            index: {
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreDefaultAssociationMapper: true
            }
        }
    });

    return collection;
});